import React, { useEffect, useState } from 'react';
import { CreditCard } from 'lucide-react';
import { supabase } from '../utils/supabase';

const Profile = () => {
  const [user, setUser] = useState<{
    email: string;
    customer_portal_link?: string;
  } | null>(null);

  useEffect(() => {
    const fetchUser = async () => {
      const { data: { user: authUser } } = await supabase.auth.getUser();
      if (authUser) {
        const { data: userData } = await supabase
          .from('users')
          .select('email, customer_portal_link')
          .eq('id', authUser.id)
          .single();
        setUser(userData);
      }
    };
    fetchUser();
  }, []);

  return (
    <div className="animate-fade-in">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Profile Settings</h1>

      <div className="max-w-2xl space-y-8">
        <div className="bg-white p-6 rounded-xl border-2 border-dark shadow-retro">
          <h2 className="text-xl font-semibold text-gray-900 mb-6">Account Information</h2>
          
          <div className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                value={user?.email || ''}
                disabled
                className="w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-lg text-gray-600"
              />
            </div>

            <div>
              <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700 mb-1">
                New Password
              </label>
              <input
                type="password"
                id="newPassword"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary"
                placeholder="Enter new password"
              />
            </div>

            <div>
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-1">
                Confirm New Password
              </label>
              <input
                type="password"
                id="confirmPassword"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary"
                placeholder="Confirm new password"
              />
            </div>

            <button className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors">
              Update Password
            </button>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl border-2 border-dark shadow-retro">
          <h2 className="text-xl font-semibold text-gray-900 mb-6">Billing</h2>
          <button 
            onClick={() => user?.customer_portal_link && window.open(user.customer_portal_link, '_blank')}
            disabled={!user?.customer_portal_link}
            className="flex items-center gap-2 px-4 py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors"
          >
            <CreditCard className="h-5 w-5" />
            Manage Your Billing
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;